import {useEffect, useState} from 'react';
import './assets/css/FatalError.scss'
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {withLang} from "../../routes/LangLayout";

function FatalError() {
    const {t} = useTranslation();
    const [message, setMessage] = useState('');
    const {shopId, lang} = useParams();

    useEffect(() => {
        const error = localStorage.getItem('fatal_error_message') as string;
        setMessage(error);
    }, []);

    return (
        <div className="reload-container">
            <div>
                <img src="/error.png" alt="error"/>
                <div>
                    <p>{t("fatalError.title")}</p>
                    <span>{message}</span>
                </div>
            </div>
            <button onClick={() => (window.location.href = withLang(`/${shopId}`, lang))}>
                {t("fatalError.reload")}
            </button>
        </div>
    );
}

export default FatalError;
